export type MemberRole = "Admin" | "Member";

export interface Member {
  id: string;
  userId: string;
  name: string;
  email: string;
  joinedAt: string;
  role: MemberRole;
}

export interface InviteMembersPayload {
  emails: string[];
}

export interface ApiResponse {
  success: boolean;
  message: string;
}

export interface Invitation {
  id: string;
  email: string;
  invitedAt: string;
  status: "Pending" | "Accepted";
}

export enum MEMBER_ROLES {
  ADMIN = "Admin",
  MEMBER = "Member",
}

export enum TEAM_MEMBER_INVITATION_STATUS {
  PENDING = "pending",
  ACCEPTED = "accepted",
}
